import React, { Suspense, useEffect, useRef, useState, lazy } from 'react';

const PipelineLeak3D = lazy(() => import('./PipelineLeak3D'));

/**
 * Only mounts the heavy Three.js pipeline scene once the user scrolls near it.
 * Saves ~200 KB of JS + WebGL initialization cost on initial page load,
 * improving LCP and INP scores in Core Web Vitals.
 */
export default function PipelineLeak3DLazy() {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!ref.current) return;
    if (typeof IntersectionObserver === 'undefined') {
      setVisible(true);
      return;
    }
    const obs = new IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting)) {
          setVisible(true);
          obs.disconnect();
        }
      },
      { rootMargin: '300px' }
    );
    obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <div ref={ref} className="w-full min-h-[340px] sm:min-h-[420px] md:min-h-[600px]" data-testid="pipeline-3d-lazy">
      {visible ? (
        <Suspense fallback={<div className="w-full h-[340px] sm:h-[420px] md:h-[600px] bg-slate-100/40" />}>
          <PipelineLeak3D />
        </Suspense>
      ) : (
        <div className="w-full h-[340px] sm:h-[420px] md:h-[600px] bg-slate-100/40 grid place-items-center">
          <div className="font-mono-tech text-[10px] uppercase tracking-[0.2em] text-slate-400">
            3D-Szene wird geladen, sobald sichtbar
          </div>
        </div>
      )}
    </div>
  );
}
